import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import Status from '@components/ui/Status';
import * as Styled from './TruckerStatusStyles';
import { TruckerStatusPropsInterface } from './TruckerStatusTypes';
import TruckerAvatar from '../TruckerAvatar/TruckerAvatar';

function TruckerStatus({
  avatar,
  name,
  status,
  hasOpacity = false,
}: TruckerStatusPropsInterface) {
  return (
    <Styled.Content>
      <FuelFlex defaultProps={{ alignItems: 'center', gap: 'km3' }}>
        <TruckerAvatar name={name} photo={avatar} hasOpacity={hasOpacity} />
        <div>
          <FuelTypography
            data-testid="trucker-name"
            tag="p"
            size="body-sm"
            color="neutral-default"
            weight="medium"
          >
            {name.toLocaleLowerCase()}
          </FuelTypography>
          <Status status={status} />
        </div>
      </FuelFlex>
    </Styled.Content>
  );
}

export default TruckerStatus;
